<div class="row">
    <div class="col-md-12 grid-margin">
        <div class="row">
            <div class="col-12 col-xl-5 mb-4 mb-xl-0">
                <h4 class="font-weight-bold">
                    {{ 'hello' | localise }} {{ usersService.userProfile.first_name + ' ' + usersService.userProfile.last_name }}!
                </h4>
                <h4 class="font-weight-normal mb-0">Master Dashboard</h4></div>
            <div class="col-12 col-xl-7">
                <div class="dashboard-status d-flex align-items-center justify-content-between flex-wrap">
                    <!--                    <div class="mb-3 mb-xl-0"><p _ngcontent-cha-c3="" class="text-muted">Balance</p><h4 class="mb-0 font-weight-bold">$40079.60 M</h4></div>-->
                    <!--                    <div class="divider mx-3"></div>-->
                    <!--                    <div class="mb-3 mb-xl-0"><p _ngcontent-cha-c3="" class="text-muted">Purchases</p><h4 class="mb-0 font-weight-bold">4006</h4></div>-->
                    <!--                    <div class="divider mx-3"></div>-->
                    <!--                    -->
                    <div class="mb-3 mb-xl-0"><p _ngcontent-cha-c3="" class="text-muted"></p><h4 class="mb-0 font-weight-bold"></h4></div>
                    <!--                    <div class="divider mx-3"></div>-->
                    <div class="mb-3 mb-xl-0"><p _ngcontent-cha-c3="" class="text-muted"></p><h4 class="mb-0 font-weight-bold"></h4></div>
                    <!--                    <div class="divider mx-3"></div>-->

                    <div class="mb-3 mb-xl-0 mr-3"><p _ngcontent-cha-c3="" class="text-muted">{{ 'profiles' | localise }}</p><h4 class="mb-0 font-weight-bold">{{ profiles_count }}</h4></div>
                    <div class="mb-3 mb-xl-0">
                        <a class="btn btn-warning rounded-0 text-white" routerLink="/master/profiles">{{ 'profiles' | localise }}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row" *ngIf="messages && notReadyUsers">
    <div class="col-md-8 grid-margin stretch-card">
        <div class="card">
            <div class="card-body">
                <h4 class="card-title">{{ 'unread_messages' | localise }}</h4>

                <app-alerts-components
                        *ngIf="messages.length <= 0"
                        [type]="'warning'"
                        [icon]="'fa fa-exclamation-triangle'"
                        [id]="'no_messages'"
                        [title]="'no_new_messages' | localise"
                        [disableClose]="true"
                        [message]="'no_new_messages_body' | localise"></app-alerts-components>

                <div
                        style="cursor: pointer;"
                        *ngFor="let message of messages"
                        (click)="router.navigate(['master/messages', message.sender.id])"
                        class="d-flex align-items-center pb-3 border-bottom">
                    <div class="ml-0">
                        <h6 class="mb-1">{{ message.sender.first_name + " " + message.sender.last_name }}</h6>
                        <small class="text-muted mb-0">
                            <i class="ti-location-pin mr-1"></i>
                            {{ formatCreatedTime(message.created_at) }}
                        </small>
                        <p style="padding-top: 10px;" [innerHTML]="trim(message.message) | keepHtml">
                        </p>
                    </div>
                    <i class="mdi mdi-message font-weight-bold ml-auto px-1 py-1 text-info mdi-24px"></i>
                </div>

            </div>
        </div>
    </div>

    <div class="col-md-4 grid-margin stretch-card">
        <div class="card">
            <div class="card-body" style="max-height: 350px; overflow-y: auto;">
                <h4 class="card-title">{{ 'unfinished_profiles' | localise }}</h4>

                <app-alerts-components
                        *ngIf="notReadyUsers.length <= 0"
                        [type]="'info'"
                        [icon]="'fa fa-info-circle'"
                        [id]="'no_messages'"
                        [title]="'no_unfinished_profiles' | localise"
                        [disableClose]="true"
                        [message]="'no_unfinished_profiles_body' | localise"></app-alerts-components>

                <div
                        style="cursor: pointer;"
                        *ngFor="let user of notReadyUsers"
                        (click)="router.navigate(['master/profiles/settings', user.id])"
                        class="d-flex align-items-center pb-3 border-bottom">
                    <div class="ml-0" style="padding-top: 11px;">
                        <h6 class="mb-1">{{ user.first_name + " " + user.last_name }}</h6>
                        <p style="padding-top: 10px;">
                            {{ user.email }}
                        </p>
                    </div>
                    <i class="mdi mdi mdi-account font-weight-bold ml-auto px-1 py-1 text-info mdi-24px"></i>
                </div>

            </div>
        </div>
    </div>
</div>
